import React, { useState } from 'react';
import styles from './CategoryItem.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import AddSubCategory from '../addCategory/AddSubCategory';
import ConfirmationModal from 'component/hoc/success-modal/ConfirmationModal';
import { categoriesEndpoints } from 'hooks/endpoints';
import { useDelete } from 'hooks/useDelete';

const CategoryItem = ({
  item,
  isExpanded,
  toggleExpand,
  getSubCategories,
  visibleSubCategories,
  botId,
  refetch,
  setShowAddCategory,
  setSelectedItem,
}) => {
  const [showAddSubCategory, setShowAddSubCategory] = useState(false);
  const [modalMode, setModalMode] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDelete, setSelectedDelete] = useState(null);
  const { mutate: deleteCategory, isPending: isPendingDelete } = useDelete({
    onSuccessToast: 'Deleted',
  });

  const allSubs = getSubCategories(item.categoriesId) || [];
  const subsToRender = visibleSubCategories ?? allSubs;

  const handleDelete = () => {
    deleteCategory(
      { url: categoriesEndpoints.deleteCategory(selectedDelete) },
      {
        onSuccess: () => {
          setShowDeleteModal(false);
          setSelectedDelete(null);
          refetch();
        },
      }
    );
  };

  return (
    <>
      <div className={styles['category-wrapper']} key={item.categoriesId}>
        <div className={styles['category-item-container']}>
          <div
            className={`${styles['category-name-container']} ${
              isExpanded ? styles.expanded : ''
            }`}
            onClick={() => toggleExpand(item.categoriesId)}
          >
            <SvgWithBranding
              type='chevronDown'
              color='#000'
              className={styles['chevron']}
            />
            <span className={styles['category-name']}>
              {item?.categoryText}
            </span>
          </div>

          <div className={styles['category-actions']}>
            <div className={styles['total']}>{allSubs.length} total</div>
            <SvgWithBranding
              type='add'
              className={styles['icon']}
              onClick={() => {
                setActiveItem(item);
                setModalMode('add-sub');
                setShowAddSubCategory(true);
              }}
            />
            <SvgWithBranding
              type='edit'
              className={styles['icon']}
              onClick={() => {
                setSelectedItem(item);
                setShowAddCategory(true);
              }}
            />
            <SvgWithBranding
              type='delete2'
              className={styles['icon']}
              onClick={() => {
                setShowDeleteModal(true);
                setSelectedDelete(item?.categoriesId);
              }}
            />
          </div>
        </div>

        {isExpanded && subsToRender?.length > 0 && (
          <div className={styles['expanded-content']}>
            <div className={styles['sub-category-container']}>
              {subsToRender.map((sub) => (
                <div
                  key={sub.categoriesId}
                  className={styles['sub-category-item']}
                >
                  <div className={styles['sub-category-item-container']}>
                    <span className={styles['sub-category-title']}>
                      {sub.categoryText}
                    </span>
                    <span className={styles['sub-category-subtitle']}>
                      {sub.description}
                    </span>
                  </div>
                  <div className={styles['sub-category-actions']}>
                    <SvgWithBranding
                      type='edit'
                      className={styles['icon']}
                      onClick={() => {
                        setActiveItem(sub);
                        setModalMode('edit-sub');
                        setShowAddSubCategory(true);
                      }}
                    />
                    <SvgWithBranding
                      type='delete2'
                      className={styles['icon']}
                      onClick={() => {
                        setShowDeleteModal(true);
                        setSelectedDelete(sub?.categoriesId);
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <AddSubCategory
        isOpen={showAddSubCategory}
        onClose={() => {
          setShowAddSubCategory(false);
          setActiveItem(null);
          setModalMode(null);
        }}
        botId={botId}
        refetch={refetch}
        item={activeItem}
        mode={modalMode}
      />

      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onSubmit={handleDelete}
        closeOnSubmit={true}
        onApproveButton={{ text: 'Delete' }}
        text='Delete Department?'
        subText='Deleting this department will also remove all associated degrees. Do you want to proceed?'
        isLoading={isPendingDelete}
        subTextClassName={styles.modalSubText}
        modalContentClassName={styles.modalContentClassName}
        buttonClassName={styles.buttonClassName}
        closeBtnContainerClassName={styles.closeBtnContainer}
        closeBtnClassName={styles.closeBtn}
      />
    </>
  );
};

export default CategoryItem;
